import O_HeaderResponsive from '@/components/O_Organisms/O_Header/O_HeaderResponsive';
import styles from './AboutPage.module.css';
import O_Footer from '@/components/O_Organisms/O_Footer/O_Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';
import Q_AboutImage01 from '@/assets/images/Q_AboutPageImages/Q_AboutImage01.png';
import Q_AboutImage02 from '@/assets/images/Q_AboutPageImages/Q_AboutImage02.png';
import Q_AboutImage03 from '@/assets/images/Q_AboutPageImages/Q_AboutImage03.png';
import Q_AboutImage04 from '@/assets/images/Q_AboutPageImages/Q_AboutImage04.png';
import Q_AboutImage05 from '@/assets/images/Q_AboutPageImages/Q_AboutImage05.png';
import Q_AboutImage06 from '@/assets/images/Q_AboutPageImages/Q_AboutImage06.png';
import Q_AboutImage07 from '@/assets/images/Q_AboutPageImages/Q_AboutImage07.png';
import Q_AboutImage08 from '@/assets/images/Q_AboutPageImages/Q_AboutImage08.png';
import Q_AboutImageRock from '@/assets/images/Q_AboutPageImages/Q_AboutImageRock.png';
import cn from 'classnames';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { PATHS } from '@/constants/paths';

/**
 * Текст карточки: каждая строка — отдельный абзац.
 * «# » — заголовок пункта, «## » — подзаголовок.
 */
const renderCardText = (text: string) =>
  text.split('\n').map((line, index) => {
    if (line.startsWith('## ')) {
      return (
        <p
          key={index}
          className={cn(styles.card_text, styles.card_subtitle, 'text-p-2')}
        >
          {line.slice(3)}
        </p>
      );
    }
    if (line.startsWith('# ')) {
      return (
        <h3 key={index} className={cn(styles.card_text, styles.card_heading)}>
          {line.slice(2)}
        </h3>
      );
    }
    return (
      <p key={index} className={cn(styles.card_text, 'text-p-2')}>
        {line}
      </p>
    );
  });

export default function AboutPage() {
  const { language } = useLanguage();

  return (
    <>
      <O_HeaderResponsive showCreateButton={false} showSearchInput={false} />
      <div className={styles.wrapper}>
        <h1 className={styles.title}>
          {getTranslation(language, 'header.about')}
        </h1>
        <main className={styles.content}>
          <section className={styles.section_01}>
            <div className={cn(styles.card_wrapper, 'effect-candle-glow')}>
              <>
                {renderCardText(
                  getTranslation(language, 'aboutPage.section01.text')
                )}
              </>
            </div>
            <div className={styles.image_wrapper}>
              <img src={Q_AboutImage01} alt='About 01' />
            </div>
          </section>
          <section className={styles.section_02}>
            <div className={styles.card_wrapper}>
              <Q_Icon.StarIcon width={24} height={24} />
              <>
                {renderCardText(
                  getTranslation(language, 'aboutPage.section02.text1')
                )}
              </>
              <>
                {renderCardText(
                  getTranslation(language, 'aboutPage.section02.text2')
                )}
              </>
            </div>
            <div className={styles.image_wrapper}>
              <img src={Q_AboutImage02} alt='About 02' />
            </div>
          </section>
          <section className={styles.section_03}>
            <div className={styles.card_wrapper}>
              <>
                {renderCardText(
                  getTranslation(language, 'aboutPage.section03.text')
                )}
              </>
            </div>
            <h1 className={styles.display_text}>
              {getTranslation(language, 'aboutPage.section03.displayText')}
            </h1>
            <div className={styles.image_wrapper}>
              <img src={Q_AboutImage03} alt='About 03' />
            </div>
          </section>
          <section className={styles.section_04}>
            <div className={styles.image_wrapper}>
              <img src={Q_AboutImage04} alt='About 04' />
            </div>
            <div className={styles.section_04_content}>
              <div className={styles.image_wrapper}>
                <img src={Q_AboutImage05} alt='About 05' />
              </div>
              <div className={styles.card_wrapper}>
                <Q_Icon.PlantIcon width={24} height={24} />
                <>
                  {renderCardText(
                    getTranslation(language, 'aboutPage.section04.text')
                  )}
                </>
              </div>
              <div className={styles.image_wrapper}>
                <img src={Q_AboutImage06} alt='About 06' />
              </div>
            </div>
          </section>
          <section className={styles.section_05}>
            <div className={styles.image_wrapper}>
              <img src={Q_AboutImage07} alt='About 07' />
            </div>
            <div className={styles.section_05_content}>
              <div className={styles.card_wrapper}>
                <>
                  {renderCardText(
                    getTranslation(language, 'aboutPage.section05.text1')
                  )}
                </>
              </div>
              <div className={cn(styles.card_wrapper, 'effect-candle-glow')}>
                <p className={cn(styles.card_text, 'text-p-2')}>
                  {getTranslation(language, 'aboutPage.section05.text2')}
                </p>
                <p className={cn(styles.card_text, 'text-p-2')}>
                  {getTranslation(language, 'aboutPage.section05.text3')}
                </p>
              </div>
            </div>
            <div className={styles.image_rock_wrapper}>
              <img src={Q_AboutImageRock} alt='About Rock' />
            </div>
            <Q_Icon.LogoSign width={300} height={300} />
          </section>
          <section className={styles.section_06}>
            <h2 className={styles.display_text}>
              {getTranslation(language, 'aboutPage.section06.title')}
            </h2>
            <A_Button
              size='large'
              variant='primary'
              onClick={() => {
                window.location.href = PATHS.CAPSULE_CREATE;
              }}
              icon={
                <Q_Icon.StarIcon
                  width={24}
                  height={24}
                  stroke='white'
                  fill='none'
                />
              }
              showIcon={true}
              fontSize='text-button'
            >
              {getTranslation(language, 'aboutPage.section06.button')}
            </A_Button>
            <div className={styles.image_wrapper}>
              <img src={Q_AboutImage08} alt='About 08' />
            </div>
          </section>
        </main>
        <O_Footer />
      </div>
    </>
  );
}
